<template>
  <div>
    <v-layout wrap>
      <v-flex sm12>
        <p class="title">
          <v-btn text icon color="grey" @click="$router.go(-1)" class="mr-4">
            <v-icon large>mdi-arrow-left</v-icon>
          </v-btn>Opciones de datos personles para
          <span class="indigo--text">{{ $route.params.orgName }}</span>
        </p>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex sm12 v-if="dataOptions.length > 0">
        <DataOptionsCard
          v-for="(dataOption, index) in dataOptions"
          :dataOption="dataOption"
          :key="index"
          @updateOptions="getData"
          class="mt-5"
        ></DataOptionsCard>
      </v-flex>
      <v-flex v-else>
        <p>Aún no hay opciones en la plataforma</p>
      </v-flex>
    </v-layout>

    <v-snackbar v-model="snackbar" top right>
      {{ message }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import DataOptionsCard from "@/components/DataOptionsCard";
import axios from "axios";
export default {
  components: {
    DataOptionsCard
  },
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      personalData: "",
      snackbar: false,
      message: "",
      dataOptions: [],
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    getData() {
      let data = {
        idUser: this.$route.params.idUser
      };
      axios
        .post(
          this.host + "/personaldataoptions/read.php",
          this.createFormData(data)
        )
        .then(response => {
          this.dataOptions = [];
          this.dataOptions = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.getData();
  }
};
</script>